module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "update-stats": _vm.refreshStats
    }
  }, [_c('data-table', {
    ref: "sitetable",
    attrs: {
      "title": this.title ? this.title : (this.menu === 'all' ? 'All Sites' : _vm.titleCase(this.menu, '-') + ' Sites'),
      "title-class": _vm.titleClass(_vm.menu),
      "title-heading": "h2",
      "icon": "fa fa-broadcast-tower",
      "table-ref": "sitetable",
      "url": _vm.url,
      "add-action": _vm.isTelco() ? null : (_vm.isManager() ? _vm.action : null),
      "add-props": _vm.addProps,
      "bottom-comp": _vm.bComp,
      "bottom-comp-props": _vm.addProps,
      "fields": _vm.siteFields,
      "sort-field": _vm.sortFields,
      "show-refresh": true,
      "params": _vm.props,
      "search-placeholder": "Site IDs, Site Names, Address...",
      "detail-component": "site-detail-row"
    },
    scopedSlots: _vm._u([{
      key: "site",
      fn: function(props) {
        return [_c('el-card', {
          attrs: {
            "body-style": {
              backgroundColor: _vm.siteBgColor(props.rowData.status),
              paddingLeft: '1.2em',
              paddingRight: '1.2em',
              minHeight: '183px'
            },
            "shadow": "hover"
          }
        }, [(props.rowData) ? _c('el-row', {
          attrs: {
            "gutter": 12
          }
        }, [_c('el-col', {
          attrs: {
            "span": _vm.isTelco() ? 18 : 24
          }
        }, [_c('h4', {
          class: _vm.titleClass(props.rowData.status)
        }, [_vm._v(_vm._s(props.rowData.siteName) + "\n                 "), (props.rowData.telcoSiteId) ? _c('span', {
          staticClass: "siteid-bubble"
        }, [_c('b', [_vm._v(_vm._s(props.rowData.telcoSiteId))])]) : _vm._e(), _vm._v(" "), (_vm.isCandidate(props.rowData.status)) ? _c('span', [_vm._v("\n                    "), _c('org-badge', {
          attrs: {
            "organisation": props.rowData.candidate
          }
        })], 1) : _vm._e(), _vm._v(" "), (_vm.isTelco() && props.rowData.status === 'Active') ? _c('el-col', {
          staticClass: "pull-right",
          attrs: {
            "span": 8
          }
        }, [(!props.rowData.stats.rtu || props.rowData.stats.rtu === 0) ? _c('el-col', {
          attrs: {
            "span": 8,
            "align": "center"
          }
        }, [_c('request-action', {
          attrs: {
            "button-size": "mini",
            "button-type": "round",
            "type": "RTU",
            "site-id": props.rowData.id,
            "row-data": props.rowData
          }
        })], 1) : _vm._e(), _vm._v(" "), (!props.rowData.stats.rtb || props.rowData.stats.rtb === 0) ? _c('el-col', {
          attrs: {
            "span": 8,
            "align": "center"
          }
        }, [_c('request-action', {
          attrs: {
            "button-size": "mini",
            "button-type": "round",
            "type": "RTB",
            "site-id": props.rowData.id,
            "row-data": props.rowData
          }
        })], 1) : _vm._e()], 1) : _vm._e()], 1)]), _vm._v(" "), _c('el-col', {
          attrs: {
            "xs": 24,
            "sm": 24,
            "md": 12,
            "lg": 12
          }
        }, [(_vm.isTowerCo()) ? _c('span', {
          domProps: {
            "innerHTML": _vm._s(_vm.formatSiteStatus(props.rowData.status))
          }
        }) : _vm._e(), _vm._v("\n                 "), _c('span', {
          staticClass: "text-muted"
        }, [_vm._v(_vm._s(props.rowData.siteId)), (props.rowData.siteGroup) ? _c('b', [_vm._v(" " + _vm._s(props.rowData.siteGroup))]) : _vm._e()]), _vm._v(" "), (_vm.isStats(props.rowData)) ? _c('site-stats', {
          attrs: {
            "site-id": props.rowData.id,
            "stats": props.rowData.stats,
            "show-shadow": _vm.showMap ? true : false
          }
        }) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "justify": "center",
            "xs": 24,
            "sm": 24,
            "md": 12,
            "lg": 12,
            "align": "center"
          }
        }, [_c('site-card', {
          attrs: {
            "site-data": props.rowData,
            "use-leaflet": "",
            "hide-site": "",
            "height": "258px"
          }
        })], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 12,
            "align": "left"
          }
        }, [(_vm.isTowerCo() && (props.rowData.dismantled || props.rowData.handover)) ? _c('div', [(props.rowData.dismantled && props.rowData.status === 'Dismantled') ? _c('span', [_c('span', {
          staticClass: "text-danger"
        }, [_c('small', [_vm._v("Dismantled")]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.formatDate(props.rowData.dismantled)))])])]) : _c('span', [_c('span', {
          staticClass: "text-info"
        }, [_c('small', [_vm._v("Handover")]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.formatDate(props.rowData.handover)))])])])]) : _c('div', [_c('span', {
          staticClass: "text-black"
        }, [(props.rowData.onAir) ? _c('small', [_vm._v("On Air")]) : _vm._e(), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.formatDate(props.rowData.onAir)))])])])]), _vm._v(" "), _c('span', {
          staticClass: "pull-right text-muted",
          staticStyle: {
            "z-index": "99"
          }
        }, [_c('small', [_vm._v("Last Update ")]), _vm._v(" "), _c('el-tooltip', {
          attrs: {
            "content": _vm.formatDateTime(props.rowData.updated_at) + (props.rowData.updated_by ? ' by ' + props.rowData.updated_by : '')
          }
        }, [_c('strong', [_vm._v(_vm._s(_vm.formatFriendlyDate(props.rowData.updated_at)))])])], 1), _vm._v(" "), (_vm.canDeleteSite(props.rowData) && _vm.isDesktop) ? _c('el-button', {
          attrs: {
            "icon": "fa fa-trash",
            "size": "small",
            "type": "danger",
            "circle": ""
          },
          on: {
            "click": function($event) {
              return _vm.deleteSite(props.rowData)
            }
          }
        }) : _vm._e()], 1)]
      }
    }])
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ac785a7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tables/SitesTable.vue
// module id = 1351
// module chunks = 0